export default __webpack_public_path__ + "static/media/19.f66e7ba0.png";